import axios from 'axios'
import Swal from 'sweetalert2'

const API_URL = process.env.REACT_APP_API_URL

// ✅ Fetch welcome message
export const fetchWelcomeMessage = async (botId) => {
    try {
        const response = await axios.get(`${API_URL}/customizeBotWelcomeMessage/${botId}`)
        return response.data.welcomeMessage // assuming response includes { welcomeMessage: "..." }
    } catch (error) {
        console.error('Error fetching welcome message:', error)
        throw error
    }
}

// ✅ Create or update welcome message
export const createOrUpdateWelcomeMessage = async (botId, welcomeMessage) => {
    try {
        const response = await axios.post(`${API_URL}/customizeBotWelcomeMessage/${botId}`, {
            welcomeMessage,
        })
        if (response.status === 200) {
            Swal.fire({
                icon: 'success',
                title: 'Welcome Message Saved',
                showConfirmButton: false,
                timer: 1500,
            })
        }
        return response.data
    } catch (error) {
        console.error('Error saving welcome message:', error)
        Swal.fire({
            icon: 'error',
            title: 'Failed to save welcome message',
        })
        throw error
    }
}
